<template>
    <div class="builds-list__component">
        <div class="loading" v-if="loading">Loading...</div>
        <ba-desktop-version v-if="mode == 'desktop'" :companyId="companyId"></ba-desktop-version>

        <h4 v-if="builds && builds.length > 0"class="u-mt4" >Previous builds:</h4>
        <el-table v-loading="loadingTable" v-if="builds && builds.length > 0" :data="builds">
            <el-table-column
                    label="Operations"
                    width="180">
                <template slot-scope="scope">
                    <el-button @click="$router.push({ name: 'build-details-' + mode, params: { buildId: scope.row.id}})">
                        Details
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column
                    prop="status"
                    label="Status"
                    width="180">
                <template slot-scope="scope">
                    <ba-status-label :build="scope.row"></ba-status-label>

                </template>
            </el-table-column>
            <el-table-column
                prop="comment"
                label="Comment"
                width="300"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.comment }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                    prop="build_number"
                    label="#"
                    width="180">
                <template slot-scope="scope">
                    {{scope.row.version}}.{{scope.row.build_number}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="queued_at"
                    label="Queued At"
                    width="160"
            >
                <template slot-scope="scope">
                    <div :title="'Time is local. \n UTC:' + scope.row.queued_at">{{scope.row.queued_at |
                        moment('YYYY-MM-DD HH:mm')}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="Completed">
                <template slot-scope="scope">
                    <ba-build-completed-date :at="scope.row.completed_at"></ba-build-completed-date>
                </template>
            </el-table-column>

        </el-table>
        <h3 class="c-heading u-text--center" v-if="builds && builds.length === 0">
            There are no builds to show yet...
        </h3>
        <div v-if="builds" class="u-text--sm u-text--light u-text--right u-mt4">50 latest builds shown</div>
    </div>
</template>

<script>
  import axios from 'axios'
  import config from '@/config'
  import router from '@/router'
  import ElButton from 'element-ui/packages/button/src/button'
  import DesktopVersion from './desktop-version.component'
  import _ from 'lodash'
  import {mapGetters} from 'vuex'

  export default {
    components: {ElButton, 'ba-desktop-version': DesktopVersion},
    props: {
      mode: {
        type: String,
        default: 'mobile', // or 'desktop'

      },
    },
    watch: {
      mode: function (newVal, oldVal) { // watch it
        this.loadBuilds()
      }
    },
    name: 'baBuildList',
    data () {
      return {
        companyId: this.$route.params.companyId,
        timerRef: null,
        loading: true,
        loadingTable: false,
        builds: null,
        commitId: null,
      }
    },
    computed: {
      ...mapGetters('shared', ['isSuperuser']),
      buildsUrl () {
        if (this.mode === 'mobile') {
          return '/builds/'
        }
        if (this.mode === 'desktop') {
          return '/builds/desktop/'
        }

        console.warn('query param mode is not passed or has invalid value')
        return '/builds/'
      }
    },
    methods: {
      goLink (link) {
        router.push({path: link})
      },
      loadBuilds () {
        clearTimeout(this.timerRef)
        this.loadingTable = true
        let url = config.url + `/company/${this.companyId}${this.buildsUrl}`
        axios.get(url)
          .then(response => {
            this.loadingTable = false
            this.loading = false
            this.builds = response.data
            let pendingBuildsExist = _.some(
              this.builds, (build) => {
                return ['queued', 'IN_PROGRESS'].indexOf(build.status) !== -1
              }
            )

            let timeout = pendingBuildsExist ? 15000 : 60000
            this.timerRef = setTimeout(this.loadBuilds, timeout)
          })
          .catch(e => {
            this.loading = false
            this.$notify.error({
              title: 'Error',
              message: 'Failed to load builds',
            })
            this.builds = null
          })
      },
    },
    beforeMount () {
      this.loading = true
      this.loadBuilds()
    },
    beforeDestroy () {
      clearTimeout(this.timerRef)
    }
  }
</script>
<style scoped>
    .builds-list__component {
        padding: 2em;
    }

    .builds-list__item {
        padding: 1em;
    }

    .build__date,
    .build__status,
    .build__details {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>
